import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page51"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "28%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "one"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "two"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "three"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "four"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "five"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = ["src"];
const _hoisted_34 = ["src"];
const _hoisted_35 = ["src"];
const _hoisted_36 = ["src"];

// 引入图片
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import wenzi1 from '@/assets/v2/page5-1-3/文字/wenzi1.webp';
import wenzi2 from '@/assets/v2/page5-1-3/文字/wenzi2.webp';
import vs from '@/assets/v2/page5-1-1/文字/a/7.webp';
import a组1 from '@/assets/v2/page5-1-4/文字/a/组 1.webp';
import a组2 from '@/assets/v2/page5-1-4/文字/a/组 2.webp';
import a组3 from '@/assets/v2/page5-1-4/文字/a/组 3.webp';
import a组4 from '@/assets/v2/page5-1-4/文字/a/组 4.webp';
import b组1 from '@/assets/v2/page5-1-4/文字/b/组 1.webp';
import b组2 from '@/assets/v2/page5-1-4/文字/b/组 2.webp';
import b组3 from '@/assets/v2/page5-1-4/文字/b/组 3.webp';
import b组4 from '@/assets/v2/page5-1-4/文字/b/组 4.webp';
import c组1 from '@/assets/v2/page5-1-4/文字/c/组 1.webp';
import c组2 from '@/assets/v2/page5-1-4/文字/c/组 2.webp';
import c组3 from '@/assets/v2/page5-1-4/文字/c/组 3.webp';
import c组4 from '@/assets/v2/page5-1-4/文字/c/组 4.webp';
import d组1 from '@/assets/v2/page5-1-4/文字/d/组 1.webp';
import d组2 from '@/assets/v2/page5-1-4/文字/d/组 2.webp';
import d组3 from '@/assets/v2/page5-1-4/文字/d/组 3.webp';
import d组4 from '@/assets/v2/page5-1-4/文字/d/组 4.webp';
import e组1 from '@/assets/v2/page5-1-4/文字/e/组 1.webp';
import e组2 from '@/assets/v2/page5-1-4/文字/e/组 2.webp';
import e组3 from '@/assets/v2/page5-1-4/文字/e/组 3.webp';
import e组4 from '@/assets/v2/page5-1-4/文字/e/组 4.webp';
export default {
  __name: 'Page5-1-4',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(wenzi2),
        alt: "wenzi2",
        class: "wenzi2",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        src: _unref(vs),
        alt: "vs",
        class: "vs",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(a组1),
        alt: "",
        srcset: "",
        class: "a组1",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(a组2),
        alt: "",
        srcset: "",
        class: "a组2",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(a组3),
        alt: "",
        srcset: "",
        class: "a组3",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(a组4),
        alt: "",
        srcset: "",
        class: "a组4",
        loading: "lazy"
      }, null, 8, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
        src: _unref(vs),
        alt: "vs",
        class: "vs",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(b组1),
        alt: "",
        srcset: "",
        class: "a组1",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(b组2),
        alt: "",
        srcset: "",
        class: "a组2",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(b组3),
        alt: "",
        srcset: "",
        class: "a组3",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(b组4),
        alt: "",
        srcset: "",
        class: "a组4",
        loading: "lazy"
      }, null, 8, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
        src: _unref(vs),
        alt: "vs",
        class: "vs",
        loading: "lazy"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _unref(c组1),
        alt: "",
        srcset: "",
        class: "a组1",
        loading: "lazy"
      }, null, 8, _hoisted_21), _createElementVNode("img", {
        src: _unref(c组2),
        alt: "",
        srcset: "",
        class: "a组2",
        loading: "lazy"
      }, null, 8, _hoisted_22), _createElementVNode("img", {
        src: _unref(c组3),
        alt: "",
        srcset: "",
        class: "a组3",
        loading: "lazy"
      }, null, 8, _hoisted_23), _createElementVNode("img", {
        src: _unref(c组4),
        alt: "",
        srcset: "",
        class: "a组4",
        loading: "lazy"
      }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
        src: _unref(vs),
        alt: "vs",
        class: "vs",
        loading: "lazy"
      }, null, 8, _hoisted_26), _createElementVNode("img", {
        src: _unref(d组1),
        alt: "",
        srcset: "",
        class: "a组1",
        loading: "lazy"
      }, null, 8, _hoisted_27), _createElementVNode("img", {
        src: _unref(d组2),
        alt: "",
        srcset: "",
        class: "a组2",
        loading: "lazy"
      }, null, 8, _hoisted_28), _createElementVNode("img", {
        src: _unref(d组3),
        alt: "",
        srcset: "",
        class: "a组3",
        loading: "lazy"
      }, null, 8, _hoisted_29), _createElementVNode("img", {
        src: _unref(d组4),
        alt: "",
        srcset: "",
        class: "a组4",
        loading: "lazy"
      }, null, 8, _hoisted_30)]), _createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
        src: _unref(vs),
        alt: "vs",
        class: "vs",
        loading: "lazy"
      }, null, 8, _hoisted_32), _createElementVNode("img", {
        src: _unref(e组1),
        alt: "",
        srcset: "",
        class: "a组1",
        loading: "lazy"
      }, null, 8, _hoisted_33), _createElementVNode("img", {
        src: _unref(e组2),
        alt: "",
        srcset: "",
        class: "a组2",
        loading: "lazy"
      }, null, 8, _hoisted_34), _createElementVNode("img", {
        src: _unref(e组3),
        alt: "",
        srcset: "",
        class: "a组3",
        loading: "lazy"
      }, null, 8, _hoisted_35), _createElementVNode("img", {
        src: _unref(e组4),
        alt: "",
        srcset: "",
        class: "a组4",
        loading: "lazy"
      }, null, 8, _hoisted_36)])])]);
    };
  }
};